var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeTurnoverRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13506_34404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4422 29.4412C29.9732 29.8269 29.3992 30.1324 28.7542 30.3238C28.245 30.4781 27.6926 30.5645 27.1155 30.5645C26.5385 30.5645 25.983 30.4781 25.4738 30.3238C24.8319 30.1324 24.2548 29.8269 23.7858 29.4412C23.5728 29.2653 23.3815 29.0739 23.2148 28.8672C23.2148 28.895 23.2148 28.9227 23.2148 28.9536C23.2148 29.3054 23.2982 29.6449 23.4525 29.9565C23.6376 30.3361 23.9246 30.6756 24.2888 30.9626C24.9986 31.5211 26.0015 31.8699 27.1155 31.8699C28.2265 31.8699 29.2295 31.5211 29.9423 30.9626C30.3034 30.6756 30.5935 30.3361 30.7755 29.9565C30.9298 29.6449 31.0132 29.3054 31.0132 28.9536C31.0132 28.9227 31.0132 28.895 31.0132 28.8672C30.8496 29.0739 30.6552 29.2653 30.4422 29.4412Z",
    fill: "#06513D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0132 26.8857C30.8496 27.0925 30.6552 27.2869 30.4422 27.4628C29.9732 27.8486 29.3992 28.151 28.7542 28.3454C28.245 28.4997 27.6926 28.583 27.1155 28.583C26.5385 28.583 25.983 28.4997 25.4738 28.3454C24.8319 28.151 24.2548 27.8486 23.7858 27.4628C23.5728 27.2869 23.3815 27.0925 23.2148 26.8857C23.2148 26.9135 23.2148 26.9444 23.2148 26.9722C23.2148 27.327 23.2982 27.6665 23.4525 27.9782C23.6376 28.3578 23.9246 28.6972 24.2888 28.9811C24.9986 29.5397 26.0015 29.8884 27.1155 29.8884C28.2265 29.8884 29.2295 29.5397 29.9423 28.9811C30.3034 28.6972 30.5935 28.3578 30.7755 27.9782C30.9298 27.6665 31.0132 27.327 31.0132 26.9722C31.0132 26.9444 31.0132 26.9135 31.0132 26.8857Z",
    fill: "#06513D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0132 24.9062C30.8496 25.113 30.6552 25.3043 30.4422 25.4802C29.9732 25.866 29.3992 26.1715 28.7542 26.3628C28.245 26.5171 27.6926 26.6035 27.1155 26.6035C26.5385 26.6035 25.983 26.5171 25.4738 26.3628C24.8319 26.1715 24.2548 25.866 23.7858 25.4802C23.5728 25.3043 23.3815 25.113 23.2148 24.9062C23.2148 24.934 23.2148 24.9618 23.2148 24.9927C23.2148 25.3445 23.2982 25.6839 23.4525 25.9956C23.6376 26.3752 23.9246 26.7146 24.2888 27.0016C24.9986 27.5602 26.0015 27.9089 27.1155 27.9089C28.2265 27.9089 29.2295 27.5602 29.9423 27.0016C30.3034 26.7146 30.5935 26.3752 30.7755 25.9956C30.9298 25.6839 31.0132 25.3445 31.0132 24.9927C31.0132 24.9618 31.0132 24.934 31.0132 24.9062Z",
    fill: "#06513D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0132 22.9258C30.8496 23.1325 30.6552 23.327 30.4422 23.5029C29.9732 23.8886 29.3992 24.1941 28.7542 24.3855C28.245 24.5398 27.6926 24.6231 27.1155 24.6231C26.5385 24.6231 25.983 24.5398 25.4738 24.3855C24.8319 24.1941 24.2548 23.8886 23.7858 23.5029C23.5728 23.327 23.3815 23.1325 23.2148 22.9258C23.2148 22.9536 23.2148 22.9844 23.2148 23.0122C23.2148 23.3671 23.2982 23.7065 23.4525 24.0182C23.6376 24.3978 23.9246 24.7373 24.2888 25.0243C24.9986 25.5828 26.0015 25.9285 27.1155 25.9285C28.2265 25.9285 29.2295 25.5828 29.9423 25.0243C30.3034 24.7373 30.5935 24.3978 30.7755 24.0182C30.9298 23.7065 31.0132 23.3671 31.0132 23.0122C31.0132 22.9844 31.0132 22.9536 31.0132 22.9258Z",
    fill: "#06513D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6341 20.5148C26.7329 20.5703 26.9489 20.6382 27.2853 20.7184C27.5846 20.7925 27.8222 20.8635 27.992 20.9345C28.1617 21.0054 28.2975 21.1042 28.4055 21.2307C28.5104 21.3603 28.5629 21.5085 28.5629 21.6782C28.5629 21.9004 28.4672 22.101 28.279 22.28C28.1956 22.3571 28.0907 22.425 27.9611 22.4744C27.8469 22.5238 27.7111 22.5577 27.5568 22.5824C27.5445 22.5855 27.5291 22.5855 27.5167 22.5886V23.0021H26.7144V22.5916C26.6958 22.5886 26.6773 22.5855 26.6588 22.5824C26.1465 22.5022 25.8102 22.2707 25.6497 21.8819L26.4027 21.6689C26.415 21.6936 26.4274 21.7152 26.4428 21.7368C26.5631 21.9405 26.8347 22.0763 27.131 22.0794C27.1341 22.0794 27.3069 22.0732 27.3779 22.0578C27.4673 22.0393 27.5383 22.0115 27.5939 21.9714C27.6895 21.9004 27.7389 21.814 27.7389 21.7152C27.7389 21.6103 27.6895 21.5332 27.5939 21.4807C27.4982 21.4251 27.2791 21.3572 26.9458 21.277C26.6434 21.203 26.4089 21.132 26.2391 21.061C26.0694 20.99 25.9305 20.8913 25.8225 20.7617C25.7176 20.6351 25.6651 20.487 25.6651 20.3173C25.6651 20.0951 25.7608 19.8945 25.949 19.7155C26.0354 19.6353 26.1404 19.5705 26.2669 19.5211C26.3842 19.4717 26.5199 19.4378 26.6712 19.4131C26.6866 19.41 26.6989 19.4069 26.7144 19.4069V18.9934H27.5167V19.4038C27.5352 19.4069 27.5507 19.41 27.5692 19.41C28.0815 19.4902 28.4178 19.7248 28.5814 20.1105L27.8253 20.3265C27.8099 20.2957 27.7945 20.2679 27.779 20.2432C27.6556 20.0426 27.3871 19.9161 27.097 19.9161C27.097 19.9161 26.9211 19.9223 26.8532 19.9377H26.8501C26.7607 19.9562 26.6897 19.984 26.6341 20.021C26.5385 20.0951 26.4891 20.1784 26.4891 20.2802C26.4891 20.3821 26.5385 20.4623 26.6341 20.5148ZM27.1155 18.083C24.9615 18.083 23.2148 19.3884 23.2148 20.9962C23.2148 21.5548 23.4247 22.0732 23.7858 22.5176C23.9308 22.6935 24.0974 22.857 24.2857 23.0052C24.9955 23.5637 26.0015 23.9125 27.1155 23.9125C28.2265 23.9125 29.2325 23.5637 29.9423 23.0052C30.1306 22.857 30.3003 22.6935 30.4422 22.5176C30.8033 22.0732 31.0132 21.5548 31.0132 20.9962C31.0132 19.3884 29.2696 18.083 27.1155 18.083Z",
    fill: "#06513D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13506_34404",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 24,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H37.3672V28.2203H14V14Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13506_34404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3194 22.1789H17.9926C18.1345 21.7067 18.3135 21.25 18.5265 20.8118C20.0787 17.6055 23.3653 15.3897 27.1611 15.3897C30.6575 15.3897 33.7219 17.2722 35.3976 20.0743C35.6661 20.5279 36.3172 20.531 36.5826 20.0743C36.7061 19.8582 36.703 19.5928 36.5765 19.3768C34.6631 16.1736 31.1574 14.0195 27.1611 14.0195C22.5938 14.0195 18.6715 16.8309 17.0298 20.8118C16.8446 21.2531 16.6903 21.7098 16.5669 22.1789H14.24C14.0888 22.1789 13.9931 22.3456 14.0703 22.4752L17.11 27.7399C17.1841 27.8726 17.3754 27.8726 17.4494 27.7399L20.4892 22.4752C20.5663 22.3456 20.4706 22.1789 20.3194 22.1789Z",
    fill: "#06513D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13506_34404",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 21,
    width: 24,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6211 21.9004H40.0501V35.8892H17.6211V21.9004Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13506_34404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1601 27.7389L37.1204 22.4742C37.0432 22.3446 36.855 22.3446 36.7779 22.4742L33.7381 27.7389C33.6641 27.8716 33.7567 28.0351 33.9079 28.0351H36.2471C36.0866 28.5073 35.8891 28.9671 35.6607 29.4053C34.0591 32.4666 30.8527 34.5589 27.1619 34.5589C23.684 34.5589 20.635 32.6981 18.9531 29.9207C18.6816 29.4701 18.0335 29.4701 17.7712 29.9238C17.6447 30.1398 17.6508 30.4083 17.7805 30.6243C19.6999 33.7998 23.1871 35.9291 27.1619 35.9291C31.6273 35.9291 35.4756 33.2443 37.1821 29.4053C37.3765 28.9609 37.5463 28.5042 37.682 28.0351H39.9873C40.1416 28.0351 40.2342 27.8716 40.1601 27.7389Z",
    fill: "#06513D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13506_34404",
    x: 0.8,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13506_34404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13506_34404",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeTurnoverRates);
export default __webpack_public_path__ + "static/media/EmployeeTurnoverRates.c5996f62a5828fb74af7aab9ac3db5ca.svg";
export { ForwardRef as ReactComponent };